import React from "react";

// Chakra imports
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";

import { HSeparator } from "components/separator/Separator";
import logoWhite from "assets/img/layout/logoWhite.png";

export function SidebarBrand() {
  const textColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column' px='20px'>
      <Image
        src={logoWhite}
        alt='Fit Group USA Logo'
        h='60px'
        w='auto'
        mb='10px'
        objectFit='contain'
        borderRadius='0'
      />
      <Text
        color={textColor}
        fontSize='md'
        fontWeight='700'
        mb='20px'
        textAlign='center'
      >
        Fit Group USA - Instructor Portal
      </Text>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
